module.exports = __webpack_public_path__ + "img/custom-checkbox.81101c0c.svg";